<div class="textfield-wrapper">
  @if (form) {
    <div
        [formGroup]="form"
        class="textfield width-100"
        [ngClass]="[
          isActive || modelValue ? 'is-active' : '',
          isInvalid || markInvalid ? 'is-invalid': '',
          readOnly ? 'read-only' : '',
          isRequired ? 'is-required' : '',
          styles.wrapper
        ]"
        [attr.data-test]="'textfield-' + inputName">
      @if (loading) {
        <div class="textfield-loader">
          <div class="loading-animation"></div>
        </div>
      }
    <input
        [attr.data-test]="dataTestClass"
        [type]="inputType"
        class="textfield__input"
        formControlName="{{ inputName }}"
        [min]="domain && domain.name === 'int' ? domain.min : ''"
        [max]="domain && domain.name === 'int' ? domain.max : ''"
        [id]="'textfield'+inputName"
        [value]="modelValue"
        [name]="inputName"
        [required]="isRequired"
        (keyup)="onKey($event)"
        (click)="activate()"
        (blur)="onBlur()"
        (change)="onKey($event)"
        [readonly]="readOnly"
        [trim]="trim"
        [trimWhitespaces]="trimWhitespaces"
        [multiCharToTrim]="multiCharToTrim || []"
        [maxlength]="maxLength"
    >
    @if (icon) {
      <span [ngClass]="icon"></span>
    }
    @if (!!label) {
      <label class="textfield__label" [for]="'textfield'+inputName">
        {{ getLabel() }}
      </label>
    }
  </div>
  } @else {
    <div
        class="textfield width-100"
        [ngClass]="[
        isActive || modelValue ? 'is-active' : '',
        isInvalid ? 'is-invalid': '',
        readOnly ? 'read-only' : '',
        styles.wrapper
      ]"
        [attr.data-test]="'textfield-' + inputName">
      <input
          [attr.data-test]="'input-' + inputType"
          [type]="inputType"
          class="textfield__input"
          [min]="domain && domain.name === 'int' ? domain.min : ''"
          [max]="domain && domain.name === 'int' ? domain.max : ''"
          [id]="'textfield'+inputName"
          [value]="modelValue"
          [name]="inputName"
          [required]="isRequired"
          (keyup)="onKey($event)"
          (click)="activate()"
          (blur)="onBlur()"
          (change)="onKey($event)"
          [readonly]="readOnly"
          [trim]="trim"
          [trimWhitespaces]="trimWhitespaces"
          [multiCharToTrim]="multiCharToTrim || []">
      @if (icon) {
        <span [ngClass]="icon"></span>
      }
      @if (!!label) {
        <label class="textfield__label" [for]="'textfield'+inputName">
          {{ getLabel() }}
        </label>
      }
    </div>
  }
  @if (hintText.length > 0 && hintOnError) {
    <small class="textfield__hint">{{hintText}}</small>
  }
</div>
